/*
 * @Author: zhangyugegeliuchen@didichuxing.com 
 * @Date: 2018-12-04 18:16:03
 * @Last Modified by: zhaozhaozhao
 * @Last Modified time: 2024-03-16 17:59:41
 * @Description:  x推d落地页 规则详情页
 */

<template>
  <div>
    <rich-loading v-if="showLoading" :size="20" class="pageLoading"></rich-loading>
    <div :class="{'iPad-xtd-container': isIPad, 'xtd-container': !isIPad}">
      <div :class="{'xtd-container-footer': !isIPad, 'iPad-xtd-container-footer': isIPad}">
          <div :class="{'iPad-xtd-container-detail': isIPad, 'xtd-container-detail': !isIPad}">
            <div class="content" v-if="!showLoading">
              <h3>{{$t('soda-m-i18n---奖励规则')}}</h3>
              <div class="select-city" v-if="!isIPad && !isNew">{{configInfo.activityCommon.cityName ? configInfo.activityCommon.cityName : gettext('选择城市')}}</div>
              <div class="steps part">
                <div v-if="ruleDetail.length">
                  <div v-for="(item, index) in ruleDetail" :key="index" :class="index === 2 ? 'bdr' : ''">
                    <div :class="index === 2 ? 'stitle' : 'title'">{{item.title}}</div>
                    <div v-if="item.time_display && item.time_display.startTime" :class="[0, 1].includes(index) ? 'scontent' : 'content'">
                      {{ formatTime(item.time_display.startTime) }} - {{ formatTime(item.time_display.endTime) }}
                    </div>
                    <div v-if="item.subText" :class="[0, 1].includes(index) ? 'scontent' : 'content'">{{ item.subText }}</div>
                    <div v-if="item.message" :class="[0, 1].includes(index) ? 'scontent' : 'content'">{{ item.message }}</div>
                    <ul v-if="item.steps && item.steps.length" class="step-list">
                      <li v-for="(t, i) in item.steps" :key="i" class="step-item line">
                        <div class="order-num">{{ i + 1 }}</div>
                        <div class="step-ct">
                          <div class="step-txt">
                            <h3>{{ t.subText }}</h3>
                            <div class="step-txt-content">
                            <template v-if="t.children && (t.children.length === 1)">
                              <div v-for="(ct, ci) in t.children" :key="ci" class="step-txt-contents">
                                <p>{{ ct.subText }}</p>
                              </div>
                            </template>
                            <template v-else-if="t.children && (t.children.length > 1)">
                              <div v-for="(ct, ci) in t.children" :key="ci" class="step-txt-contents">
                                <strong>{{ ct.subText }}</strong>
                                <p v-html="ct.message"></p>
                              </div>
                            </template>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                    <template v-if="item.children && item.children.length">
                      <div v-for="(st, si) in item.children" :key="si">
                        <div v-if="st.subText" class="content">{{ st.subText }}<span v-if="st.message"><a :href="st.message">{{ st.message }}</a></span><span v-if="st.hasOwnProperty('phone') && st.phone"><a class="phone" :href="'tel:' + st.phone">{{st.phone}}</a></span></div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <!-- 规则规则 end -->
          </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
 formatDateTime
} from "@didi/elvish-lib-javascript";
import SelectCity from './selectCity'
import { mapGetters, mapActions } from 'vuex'
import { getUserInfo, getRiderBackBtn } from '@/common/js/bridge'
import Schema from '@/common/js/schema'
import { globalParamsSchema } from '@/store/d/schema'

export default {
  name: 'detailRuless',
  data () {
    return {
      configInfo: {
        activityCommon: {},
        ruleDetail: {}
      },
      sourceType: 'd',
      sourceID: '',
      currentCityId: '',
      showLoading: true
    }
  },
  components: {
    SelectCity
  },
  computed: {
    ...mapGetters(['globalParams', 'xtdConfig']),
    meanfulGlobalParams () {
      return Schema.compare(this.globalParams, globalParamsSchema)
    },
    meanfulXtdConfigInfo () {
      // return Schema.compare(this.xtdConfig, xtdConfigSchema)
      return true
    },
    ruleDetail () {
      if (this.configInfo && this.configInfo.ruleDetail) {
        return Object.values(this.configInfo.ruleDetail)
      } else {
        return []
      }
    },
    isNew () {
      const { query: {isNew} = {} } = this.$route
      return +isNew === 1
    }
  },
  methods: {
    formatTime (prop) {
      // return i18nUtil.getTimeFormat({
      //   timestamp: prop && prop.timestamp * 1000,
      //   offset: prop && prop.offset,
      //   locale: getLocale(),
      //   format: 'YYYY.MM.DD'
      // })
      return formatDateTime(
        prop && prop.timestamp,
        "DATE_DD_MM_YYYY"
      )
    },
    ...mapActions(['getGlobalInfo', 'getXtdRulesDetail']),
    async getRulesDetail (param) {
      const res = await this.getXtdRulesDetail(param) || {}
      this.configInfo = res
      this.currentCityId = res?.activityCommon?.cityID
      this.showLoading = false
    },
    handleSelected (city) {
      this.currentCityId = city.cityId
    },
    getSourceInfo () {
      if (this.isInDApp) {
        return Promise.all([this.getGlobalInfo(), getUserInfo()])
          .then((data) => {
            this.sourceType = 'd'
            this.sourceID = data[1].uid
            return {
              ...data[0],
              ...data[1],
              sourceType: 'd',
              sourceID: data[1].uid || 'd'
            }
          })
          .catch((err) => {
            console.log('err', err)
          })
      }
      return Promise.resolve({})
    }
  },
  created () {
    if (this.isInDApp) getRiderBackBtn()
    // setTitle(this.gettext('推荐骑手'))
    this.getSourceInfo()
      .then((data) => {
        const { query: { cityId } = {} } = this.$route
        const param = this.isNew ? { ...data, cityId: (cityId || undefined) } : data;
        return this.getRulesDetail(param)
      })
      .then(() => {})
      .catch(err => {
        const toast = this.$createToast({
          time: 3000,
          txt: '' + err,
          type: 'error'
        })
        toast.show()
      })
  }
}
</script>

<style lang="stylus" scoped>
@import "~@/common/stylus/variables";
$conversion = 0.5859375px
.pageLoading {
  position: absolute;
  top: 50%;
  width: 100%;
}
.xtd-container {
  background: #fff;
  width: 100%
  height: 100%
  overflow-x: hidden
  overflow-y: auto
  padding-bottom: 0
  &-main {
    margin: 0 auto 32px
  }
  .cropper {
    position: fixed;
    top: 0;
    bottom: 244px;
    overflow-y: auto;
  }
  .xtd-common-income-container {
    margin: 0 32px 32px;
    border-radius: 12px;
  }
  .xtd-container-main {
    margin-bottom: 32px;
  }
  .content {
    margin: 0 0 24px
    background: #fff
    padding: 56px 33px
    text-align: left
    h3 {
      font-family: "Aspira Demi"
      font-style: normal
      text-align: left
      font-size: 40px
      color: #000
      font-weight: 500
    }
    a {
      word-break: break-word
    }
    .steps{
      .bdr {
        margin-bottom: 52px
        padding-top: 56px
        padding-bottom: 24px
        border-top: 1px #e5e5e5 solid
        border-bottom: 1px #e5e5e5 solid
      }
      .title{
        margin-bottom: 16px
        font-family: "Aspira Regular"
        font-size: 24px
        color: #999
        line-height: 40px
        font-weight: 400
      }
      .stitle{
        margin-bottom: 16px
        font-family: "Aspira Demi"
        font-size: 40px
        color: #000
        line-height: 40px
        font-weight: 600
      }
      .content{
        margin: 0 0 42px
        padding: 0
        opacity: 0.8
        font-family: "Aspira Regular"
        font-size: 28px
        color: #404040
        font-weight: 400
        letter-spacing: 0
        a{
          color: #FF7A45
        }
        .phone{
          margin-left: 6px
        }
      }
      .scontent{
        margin: 0 0 52px
        padding: 0
        opacity: 0.8
        font-family: "Aspira Regular"
        font-size: 32px
        color: #000
        font-weight: 400
        letter-spacing: 0
        a{
          color: #FF7A45
        }
        .phone {
          margin-left: 6px
        }
      }
      .step-list{
        margin-top: 56px
        .step-item{
          display flex
          &.line{
              position: relative;
              &::after {
                position: absolute;
                content: '';
                width: 0;
                display: block;
                height: 100%;
                left: 16px
                border: 2px dashed #000;
              }
            }
          &:last-child{
            &.line:after{
              display none
            }
          }
          .order-num{
            position: relative
            z-index: 1
            width: 32px;
            height: 32px;
            font-family: "PingFang-SC-Semibold";
            font-size: 24px;
            text-align: center;
            font-weight: 600;
            border-radius: 50%
            background: #000;
            color: #fff
            line-height: 32px
            text-align: center
            flex-shrink: 0
          }
          .step-ct{
            width: 100%
            margin-left 32px
            .step-txt{
              background: #F5F5F5
              border-radius: 8px
              padding: 24px
              margin: -5px auto 32px
              h3{
                margin-bottom: 12px
                font-family: "Aspira Demi"
                font-size: 32px
                color: #000
                line-height: 40px
                font-weight: 500
              }
              .step-txt-content{
                strong{
                  margin-top: 28px
                  display: block
                  margin-bottom: 9px
                  font-family: "Aspira Medium"
                  font-size: 24px
                  color: #000
                  line-height: 30px
                  font-weight: 500
                }
                strong:first-child{
                  // margin-top: 0
                }
                p{
                  font-family: "Aspira Regular"
                  font-size: 24px
                  color: #666
                  line-height: 30px
                  font-weight: 400
                }
              }
            }
          }
        }
      }
    }
  }
  .content:last-child {
    margin-bottom: 0
  }
  &-footer {
    .xtd-container-detail {
      margin-bottom: 0
      padding-bottom: 5px
      text-align: center
    }
    .detail-rules {
      color: #999
      font-size: 32px
      text-align: center
      .richic-arrow {
        color:#999999
        font-size: 24px
        margin-right: -32px
      }
    }
    // .rich-input:after {
    //   border: none;
    // }
    .line-wrap {
      display: flex;
      justify-content: left;
      .line {
        display: block;
        width: 146px;
        height: 2px;
        margin-top: 14px;
        &.r  {
          background: linear-gradient(to right, #D8D8D8 , #ffffff);
          margin-left: 24px;
        }
        &.l {
          background: linear-gradient(to right, #ffffff, #D8D8D8);
          margin-right: 24px;
        }
      }
      .text {
        font-family: 'Aspira Regular'
        font-weight: 400
        color: #666
        display: block
        font-size: 32px
        margin-bottom: 40px
      }
    }
    .select-city {
      position: relative;
      margin: 32px auto 42px;
      padding: 0 24px 0 24px;
      box-sizing: border-box;
      height: 56px;
      line-height: 56px;
      border: 1px solid #FFD8C5;;
      text-align: center;
      display: inline-block;
      border-radius: 100px;
      font-family: "Aspira Medium";
      font-size: 24px;
      color: #ffd8c5;
    }
    .code-box {
      text-align: center
      .copy-wrap {
        display: flex;
        justify-content: left;
        align-items: center;
        font-size: 0;
        .copy-btn {
          display: inline-block;
          width: 40px;
          height: 40px;
          copy-icon();
          margin-left: 15px
          box-sizing: border-box
        }
        .code {
          font-family: Aspira Medium;
          font-weight: 500;
          font-size: 48px;
          color: #000000;
          letter-spacing: 0;
          text-align: center;
          line-height: 33px;
          font-weight: bold;
          -webkit-user-select: text;
        }
      }
    }
    .share-box {
      border-top: 1px #ebebeb solid;
      margin-top: 24px;
      .title {
        font-size: 28px;
        color: #999999;
        letter-spacing: 0;
        text-align: center;
        margin-bottom: 19px;
      }
      .share-wrap >>> .icons {
        padding: 0 0 15px;
        justify-content: space-between;
        .icon {
          margin-left: 0;
        }
      }
    }
  }
}
.iPad-xtd-container {
  background: white;
  overflow-x: hidden
  overflow-y: auto
  padding: 28*$conversion  60*$conversion  60*$conversion 60*$conversion;
  display: flex
  &-main {
    margin-right: 60*$conversion
  }
  &-footer {
    position: relative
    flex:1
    .iPad-xtd-common-income-container {
      position: absolute
      bottom: 0
    }
    .iPad-xtd-container-detail {
      padding-top: 64*$conversion
    }
    .detail-rules {
      color: #4A4A4A
      font-size: 18*$conversion
      margin-top: 28*$conversion
      text-align: center
      .richic-arrow {
        color:#999999
        font-size:11*$conversion
        margin-left: 8*$conversion
      }
    }
    // .rich-input:after {
    //   border: none;
    // }
    .line-wrap {
      display: flex;
      justify-content: center;
      .line {
        display: block;
        width: 100*$conversion;
        height: 2*$conversion;
        margin-top: 9*$conversion;
        &.r  {
          background: linear-gradient(to right, #D8D8D8 , #ffffff);
          margin-left: 14*$conversion;
        }
        &.l {
          background: linear-gradient(to right, #ffffff, #D8D8D8);
          margin-right: 14*$conversion;
        }
      }
      .text {
        color: #999999
        display: block
        font-size: 20*$conversion
        text-align: center
      }
    }
    .code-box {
      margin-top: 18*$conversion
      text-align: center
      .copy-wrap {
        display: flex;
        justify-content: center;
        align-items: center
        .copy-btn {
          display: inline-block;
          width: 40*$conversion;
          height: 40*$conversion;
          copy-icon($conversion);
          margin-left: 16*$conversion
          box-sizing: border-box
        }
        .code {
          font-size: 48*$conversion;
          color: #000000;
          letter-spacing: 0;
          text-align: center;
          line-height: 48*$conversion
          font-weight: bold;
          -webkit-user-select: text;
        }
      }

    }
    .select-city {
      position: relative;
      margin: 40*$conversion auto 50*$conversion;
      padding: 0 34*$conversion 0 16*$conversion;
      min-width: 100*$conversion;
      text-align: left;
      box-sizing: border-box;
      display: inline-block;
      line-height: 42*$conversion;
      height: 42*$conversion;
      border-color(1*$conversion);
      border-radius: 100*$conversion;
      font-family: Aspira Medium;
      font-size: 18*$conversion;
      font-color();
      &::after {
        position: absolute;
        display: block;
        content: "";
        width: 6*$conversion;
        height: 10*$conversion;
        arrow-right();
        right: 20*$conversion;
        top: 50%;
        margin-top: -5*$conversion;
      }
    }
    .share-box {
      margin-top: 78*$conversion;
      .title {
        font-size: 20*$conversion;
        color: #999999;
        letter-spacing: 0;
        text-align: center;
        margin-bottom: 24*$conversion;
      }
      .share-wrap {
        color: #ff0000
        .share {
          .icons {
            padding: 0 0 15px;
            justify-content: space-between
            .icon {
              margin-left: 5px
            }
          }
        }
      }
    }
  }
}
</style>
